import React from 'react';
import MinimalDumbo from '../../../DeviationViews/Dumbo/EditorDumbo';
import { Props } from '../ThumbView';

import s from './Status.scss';

const StatusThumbReactView: React.FC<Props> = props => (
  <div
    className={s['root']}
    style={{ width: props.width, height: props.height }}
  >
    <MinimalDumbo {...props} />
  </div>
);
StatusThumbReactView.displayName = 'StatusThumbReactView';

export default StatusThumbReactView;
